export default function SectionContact() {
  const formSubmitAddr = 'https://readdy.ai/api/form/d9m7osgbdkpk99j7g7p0';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('[name="website_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      const successEl = document.getElementById('contact-success');
      if (successEl) successEl.classList.remove('hidden');
      return;
    }
    const formData = new FormData(form);
    try {
      const response = await fetch(formSubmitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (response.ok && parsed?.code === 'OK') {
        const successEl = document.getElementById('contact-success');
        if (successEl) successEl.classList.remove('hidden');
        const errorEl = document.getElementById('contact-error');
        if (errorEl) errorEl.classList.add('hidden');
        form.reset();
      } else {
        const errorEl = document.getElementById('contact-error');
        if (errorEl) {
          const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
          errorEl.textContent = msg;
          errorEl.classList.remove('hidden');
        }
      }
    } catch {
      const errorEl = document.getElementById('contact-error');
      if (errorEl) {
        errorEl.textContent = '网络错误，请稍后重试';
        errorEl.classList.remove('hidden');
      }
    }
  };

  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              联系我们
            </h2>
          </div>

          <div className="bg-background-100 rounded-2xl border border-background-200/60 p-6 md:p-10">
            <div className="flex flex-col lg:flex-row gap-8 items-start">
              <div className="flex-1 w-full">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                  投稿与反馈
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                  如果您有好的影视资源推荐、观影心得想要分享，或者在使用中遇到任何问题，
                  欢迎通过以下方式联系我们。777影院团队会在24小时内回复您的每一条消息。
                </p>

                <div className="flex flex-col gap-3">
                  <div className="flex items-center gap-3 text-sm text-foreground-600">
                    <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <span>feedback@777cinema.com</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-foreground-600">
                    <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                      <i className="ri-wechat-line text-accent-600"></i>
                    </div>
                    <span>777影院官方公众号</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-foreground-600">
                    <div className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center shrink-0">
                      <i className="ri-user-voice-line text-secondary-600"></i>
                    </div>
                    <span>欢迎投稿：优质影评、观影指南、片单推荐</span>
                  </div>
                </div>
              </div>

              <div className="w-full lg:w-[380px] shrink-0">
                <form
                  id="contact-form"
                  data-readdy-form
                  className="space-y-3"
                  onSubmit={handleSubmit}
                >
                  <input
                    type="text"
                    name="name"
                    placeholder="您的称呼"
                    className="w-full px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-lg text-sm text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="电子邮箱"
                    className="w-full px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-lg text-sm text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                  />
                  <textarea
                    name="message"
                    placeholder="请输入您的留言内容..."
                    rows={3}
                    maxLength={500}
                    className="w-full px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-lg text-sm text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                  ></textarea>
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <button
                    type="submit"
                    className="w-full px-6 py-2.5 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
                  >
                    发送消息
                  </button>
                  <p id="contact-success" className="hidden text-xs text-accent-600 text-center">
                    消息已发送，我们会尽快回复！
                  </p>
                  <p id="contact-error" className="hidden text-xs text-primary-600 text-center"></p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}